import { type FC } from "react";

import { DateTime } from "luxon";

import { Tooltip } from "./tooltip";

export const RelativeDate: FC<{
  iso?: string | null;
}> = ({ iso }) => {
  if (!iso) return null;
  const dt = DateTime.fromISO(iso);

  return (
    <Tooltip tip={dt.toLocaleString(DateTime.DATE_MED)}>
      <span>{dt.toRelative()}</span>
    </Tooltip>
  );
};
